<div class="contratos-page">
  <ng-container *ngIf="pode_configurar; else contratosNaoDisponiveis">
  <div class="contratos-header">
    <div>
      <h1>Contratos</h1>
      <p>Configure clientes, produtos e objetivo mensal de compra.</p>
    </div>

    <button type="button" class="btn btn-primary" (click)="novo()">Novo contrato</button>
  </div>

  <div class="contratos-layout">
    <section class="contratos-lista">
      <h2>Contratos ativos</h2>

      <input class="contratos-filtro" type="text" placeholder="Buscar contrato por cliente ou ERP" [(ngModel)]="filtroContratoCliente" />

      <button type="button" class="contrato-card" *ngFor="let item of contratosFiltrados" (click)="editar(item.id)">
        <strong>{{ item.nome_contrato }}</strong>
        <span>{{ item.cliente_nome }}</span>
        <small>{{ item.seller_nome || 'Sem vendedor' }}</small>
      </button>

      <div class="contratos-empty" *ngIf="!carregando && contratosFiltrados.length === 0">
        Nenhum contrato cadastrado.
      </div>
    </section>

    <section class="contratos-form">
      <div class="form-section">
        <h2>Dados do contrato</h2>

        <div class="form-row">
          <label>
            Nome do contrato
            <input type="text" [(ngModel)]="contrato.nome_contrato" />
          </label>

          <label>
            Status
            <select [(ngModel)]="contrato.status">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
              <option value="ENCERRADO">Encerrado</option>
            </select>
          </label>
        </div>

        <div class="form-row">
          <label>
            Data inicio
            <input type="date" [(ngModel)]="contrato.data_inicio" />
          </label>

          <label>
            Data fim
            <input type="date" [(ngModel)]="contrato.data_fim" />
          </label>
        </div>

        <label>
          Observacao
          <textarea rows="3" [(ngModel)]="contrato.observacao"></textarea>
        </label>
      </div>

      <div class="form-section">
        <h2>Cliente</h2>

        <div class="search-row">
          <input type="text" placeholder="Buscar por nome, fantasia, documento ou ERP" [(ngModel)]="termoCliente" (keyup.enter)="buscarClientes()" />
          <button type="button" class="btn btn-outline-primary" (click)="buscarClientes()">Buscar</button>
        </div>

        <div class="resultado-lista" *ngIf="clientes.length > 0">
          <button type="button" *ngFor="let cliente of clientes" (click)="selecionarCliente(cliente)">
            <strong>{{ cliente.name }}</strong>
            <span>ERP: {{ cliente.codigo_no_erp_do_cliente || '-' }} | {{ cliente.client_document || '-' }}</span>
          </button>
        </div>

        <div class="cliente-selecionado" *ngIf="contrato.client_id">
          <strong>{{ contrato.cliente_nome }}</strong>
          <span>ERP: {{ contrato.cliente_codigo_erp || '-' }} | Vendedor: {{ contrato.seller_nome || '-' }}</span>
        </div>
      </div>

      <div class="form-section">
        <h2>Produtos e objetivos</h2>

        <div class="search-row">
          <input type="text" placeholder="Buscar produto por nome ou codigo" [(ngModel)]="termoProduto" (keyup.enter)="buscarProdutos()" />
          <button type="button" class="btn btn-outline-primary" (click)="buscarProdutos()">Buscar</button>
        </div>

        <div class="resultado-lista" *ngIf="produtos.length > 0">
          <button type="button" *ngFor="let produto of produtos" (click)="adicionarProduto(produto)">
            <strong>{{ produto.name }}</strong>
            <span>Codigo: {{ produto.codigo || '-' }} | Estoque: {{ produto.estoque || 0 }}</span>
          </button>
        </div>

        <div class="itens-table" *ngIf="contrato.itens.length > 0">
          <div class="itens-head">
            <span>Produto</span>
            <span>Objetivo mensal</span>
            <span>Unidade</span>
            <span></span>
          </div>

          <div class="itens-row" *ngFor="let item of contrato.itens; let i = index">
            <div>
              <strong>{{ item.produto_nome }}</strong>
              <small>{{ item.produto_codigo }}</small>
            </div>
            <input type="number" min="0" step="0.01" [(ngModel)]="item.quantidade_objetivo_mensal" />
            <input type="text" [(ngModel)]="item.unidade_medida" />
            <button type="button" class="btn btn-outline-danger" (click)="removerProduto(i)">Remover</button>
          </div>
        </div>
      </div>

      <div class="contratos-actions">
        <button type="button" class="btn btn-primary" (click)="salvar()">Salvar contrato</button>
        <button type="button" class="btn btn-outline-danger" *ngIf="contrato.id" (click)="excluir(contrato)">Inativar</button>
      </div>
    </section>
  </div>
  </ng-container>

  <ng-template #contratosNaoDisponiveis>
    <section class="contrato-apresentacao">
      <div>
        <span class="new-badge">NEW</span>
        <h1>Cadastro de Contratos</h1>
        <p>Cadastre contratos por cliente e produto para acompanhar objetivo mensal, realizado e atingimento no dashboard.</p>

        <div class="apresentacao-alerta" *ngIf="!usa_contrato">
          Esta funcao ainda nao esta habilitada para o seu usuario. Entre em contato com o suporte para agendar uma apresentacao.
        </div>

        <div class="apresentacao-alerta" *ngIf="usa_contrato && !pode_configurar">
          O cadastro de contratos esta disponivel apenas para usuarios Master ou Diretoria.
        </div>
      </div>

      <div class="apresentacao-grid">
        <article>
          <strong>Cliente e vendedor</strong>
          <span>O contrato usa o cliente correto do ERP e exibe o vendedor responsavel.</span>
        </article>
        <article>
          <strong>Produtos contratados</strong>
          <span>Defina produto, unidade e objetivo mensal para cada item.</span>
        </article>
        <article>
          <strong>Dashboard executivo</strong>
          <span>Acompanhe atingimento atual e historico dos ultimos 3 meses.</span>
        </article>
      </div>
    </section>
  </ng-template>
</div>
